import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

export const BreadcrumbBox = styled(Box)`
  &:before {
    background: #fff;
    content: "";
    display: block;
    height: 50px;
    position: absolute;
    width: 50px;
    right: 25px;
    top: -7px;
    -webkit-transform: scale(2) rotate(46deg);
    transform: scale(2) rotate(46deg);
    z-index: 1;
  }
  &:after {
    background: #a3a3a3;
    content: "";
    display: block;
    height: 50px;
    position: absolute;
    width: 50px;
    right: 27px;
    top: -7px;
    -webkit-transform: scale(2) rotate(46deg);
    transform: scale(2) rotate(46deg);
    z-index: 1;
  }
`

export const BreadcrumbBoxActive = styled(Box)`
  &:before {
    background: #fff;
    content: "";
    display: block;
    height: 50px;
    position: absolute;
    width: 50px;
    right: 25px;
    top: -7px;
    -webkit-transform: scale(2) rotate(46deg);
    transform: scale(2) rotate(46deg);
    z-index: 1;
  }
  &:after {
    background: #333;
    content: "";
    display: block;
    height: 50px;
    position: absolute;
    width: 50px;
    right: 27px;
    top: -7px;
    -webkit-transform: scale(2) rotate(46deg);
    transform: scale(2) rotate(46deg);
    z-index: 1;
  }
`

export const startBorderRadius = {
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
  position: 'relative',
}

export const lastBorderRadius = {
  borderTopRightRadius: 8,
  borderBottomRightRadius: 8,
  position: 'relative',
  paddingLeft: '6%',
}
